import {
  ColDef,
  type ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { FilteredAzSqlResourceItem } from "@/services/cloudchipr.api";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azSqlColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Database Name", "db_name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_sql"),

  resourceAccountColumnDef,

  getResourceMetricsColumnDef("CPU Max", "cpu_max", "az_sql"),
  getResourceMetricsColumnDef("Connections", "total_connection_sum", "az_sql"),

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  { field: "resource.resource_group", headerName: "Resource Group" },

  {
    field: "resource.pricing_tier",
    headerName: "Pricing Tier",
    valueGetter: ({ data }: ValueGetterParams) =>
      `${data?.resource?.pricing_tier}, ${data?.resource?.instance_type}`,
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredAzSqlResourceItem>) => {
      const pricingTier = data?.resource?.pricing_tier;
      const type = data?.resource?.instance_type;

      return (
        <TypographyWithTooltip
          title={`${pricingTier}, ${type}`}
          variant="body2"
        />
      );
    },
  },

  { field: "resource.number_of_replicas", headerName: "Replicas" },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
